import { VALUATIONS_APPROACH_TYPES } from 'pages/ValuationsAllocation/common/constants/valuations';
import { AddScenarioApproachButton } from 'pages/ValuationsAllocation/components/AddScenarioApproachButton';
import { NewScenarioApproachDialog } from 'pages/ValuationsAllocation/components/NewScenarioApproachDialog';
import { AddScenarioApproachDialogProps, ApproachTypes } from './types';

const AddScenarioApproachDialog = (props: AddScenarioApproachDialogProps) => {
  const {
    disableAddApproachButton,
    disableAddScenarioButton,
    handleAddApproach,
    handleAddScenario,
    handleCloseAddApproachDialog,
    handleOpenAddApproachDialog,
    initialSelection,
    openAddApproachDialog,
    approaches,
    hasOPMConsumer,
  } = props;

  return (
    <>
      <NewScenarioApproachDialog
        approachTypes={VALUATIONS_APPROACH_TYPES as ApproachTypes[]}
        disableAddScenarioButton={disableAddScenarioButton}
        handleApproachTypeClick={handleAddApproach}
        handleScenarioTypeClick={handleAddScenario}
        initialSelection={initialSelection}
        onDialogClose={handleCloseAddApproachDialog}
        openDialog={openAddApproachDialog}
        approaches={approaches}
        hasOPMConsumer={hasOPMConsumer}
      />

      <AddScenarioApproachButton disabled={disableAddApproachButton} onClick={handleOpenAddApproachDialog} />
    </>
  );
};

export default AddScenarioApproachDialog;
